import { useSelector } from "react-redux";

import AddPrimaryGuestDrawer from "../../components/bookingDetailsV2/DrawerPages/AddPrimaryGuestDrawer";
import AddonsDrawer from "../../components/bookingDetailsV2/DrawerPages/AddonsDrawer";
import TakePaymentDrawer from "../../components/bookingDetailsV2/DrawerPages/TakePaymentDrawer";

import ApplyDiscountDrawer from "../../components/bookingDetailsV2/DrawerPages/ApplyDiscountDrawer";
import ViewFolioDrawer from "../../components/bookingDetailsV2/DrawerPages/ViewFolioDrawer";
import ViewGrcDrawer from "../../components/bookingDetailsV2/DrawerPages/ViewGrcDrawer";
import RoomDrawer from "../../components/bookingDetailsV2/DrawerPages/RoomDrawer";
import ViewInvoiceDrawer from "../../components/bookingDetailsV2/DrawerPages/ViewInvoiceDrawer";
import ViewPaymentDrawer from "../../components/bookingDetailsV2/DrawerPages/ViewPaymentDrawer";
import NewIdDrawer from "../../components/bookingDetailsV2/DrawerPages/NewIdDrawer";
import IdDrawer from "../../components/bookingDetailsV2/DrawerPages/IdDrawer";
import RefundDrawer from "../../components/bookingDetailsV2/DrawerPages/RefundDrawer";

import ExtraOptionDrawer from "../../components/bookingDetailsV2/DrawerPages/ExtraOptionDrawer";
import AttachToPartyDrawer from "../../components/bookingDetailsV2/DrawerPages/AttachToPartyDrawer";
import CheckInDrawer from "../../components/bookingDetailsV2/DrawerPages/CheckInDrawer";
import ConfirmationModalNoShow from "../../components/bookingDetailsV2/Modal/ConfirmationModalNoShow";
import DeleteBookingModal from "../../components/bookingDetailsV2/Modal/DeleteBookingModal";
import DeletePartyModal from "../../components/bookingDetailsV2/Modal/DeletePartyModal";
import CancelBookingModal from "../../components/bookingDetailsV2/Modal/CancelBookingModal";
import EditPaymentDrawer from "../../components/common/components/UpdatePaymentDrawer/EditPaymentDrawer";
import MainBookingDetailsDrawer from "../../components/bookingDetailsV2/DrawerPages/Index";
import UndoCompletedBookingModal from "../../components/bookingDetailsV2/Modal/UndoCompletedBookingModal";
import UndoNoShowBookingModal from "../../components/bookingDetailsV2/Modal/UndoNoShowCancelBookingModal";

const useAllBookingDrawerImports = () => {
  const {
    showMainBookingDetailsDrawer,
    displayPaymentPrintDrawer,
    displayInvoiceDrawer,
    showPrimaryGuestDrawer,
    showAddonsDrawer,
    showTakePaymentDrawer,
    showApplyDiscountDrawer,
    showFolio,
    showGrcDrawer,
    displayRoomDrawer,
    showExtraOptionDrawer,
    showRefundDrawer,
    showAttachToPartyDrawer,
    displayNoShowModal,
    displayDeleteBookingModal,
    displaydeletePartyModal,
    displayCancelBookingModal,
    displayCheckInDrawer,
    displayUndoCompletedBookingModal,
    displayUndoNoShowBookingModal,
  } = useSelector((store) => store.booking);

  const { hotelDetails } = useSelector((store) => store.login);

  return {
    showMainBookingDetailsDrawer,
    hotelDetails,
    drawers: (
      <>
        {showMainBookingDetailsDrawer?.visible && (
          <>
            <MainBookingDetailsDrawer />

            {displayPaymentPrintDrawer?.display && <ViewPaymentDrawer />}

            {displayInvoiceDrawer?.display && <ViewInvoiceDrawer />}

            {showPrimaryGuestDrawer?.visible && <AddPrimaryGuestDrawer />}

            {showAddonsDrawer && <AddonsDrawer />}

            {showTakePaymentDrawer && <TakePaymentDrawer />}

            {showApplyDiscountDrawer && <ApplyDiscountDrawer />}

            {showFolio && <ViewFolioDrawer />}

            {showGrcDrawer && <ViewGrcDrawer />}

            {showExtraOptionDrawer && <ExtraOptionDrawer />}

            {hotelDetails?.showRoomWisePersonWiseIdForGuests ? (
              <NewIdDrawer />
            ) : (
              <IdDrawer />
            )}

            {showRefundDrawer && <RefundDrawer />}

            {showAttachToPartyDrawer && <AttachToPartyDrawer />}

            {displayNoShowModal && <ConfirmationModalNoShow />}

            {displayDeleteBookingModal && <DeleteBookingModal />}

            {displaydeletePartyModal && <DeletePartyModal />}

            {displayCancelBookingModal && <CancelBookingModal />}

            {displayCheckInDrawer && <CheckInDrawer />}

            {displayUndoCompletedBookingModal && <UndoCompletedBookingModal />}

            {displayUndoNoShowBookingModal && <UndoNoShowBookingModal />}

            <EditPaymentDrawer
              isBookingListDrawer={true}
              drawerWidth={"800px"}
            />
          </>
        )}

        {displayRoomDrawer && <RoomDrawer />}
      </>
    ),
  };
};

export default useAllBookingDrawerImports;
